class ImageWithTextAutoplayVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video) return;

    this.hideControls = this.hasAttribute('data-hide-controls');
    this.video.muted = true;
    this.video.controls = !this.hideControls;
    this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.handleMotionChange = () => {
      if (this.motionPreference.matches || !this.isVisible) {
        this.video.pause();
        if (this.motionPreference.matches) this.video.controls = true;
      } else {
        this.video.controls = !this.hideControls;
        this.play();
      }
    };
    if (this.motionPreference.addEventListener) {
      this.motionPreference.addEventListener('change', this.handleMotionChange);
    } else {
      this.motionPreference.addListener(this.handleMotionChange);
    }

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries) => {
        this.isVisible = entries[0].isIntersecting;
        this.handleMotionChange();
      }, { threshold: 0.01 });
      this.observer.observe(this);
    } else {
      this.isVisible = true;
      this.handleMotionChange();
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    if (this.motionPreference?.removeEventListener) {
      this.motionPreference.removeEventListener('change', this.handleMotionChange);
    } else {
      this.motionPreference?.removeListener(this.handleMotionChange);
    }
    this.video?.pause();
  }

  play() {
    this.video.play().catch(() => {
      // Let visitors start the video manually if their browser blocks autoplay.
      this.video.controls = true;
    });
  }
}

if (!customElements.get('autoplay-video')) {
  customElements.define('autoplay-video', ImageWithTextAutoplayVideo);
}
